import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useLiburListModel} from "@/stores/models/libur-list-model";

export const useLiburListStore  = defineStore(
    'liburListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceLiburList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useLiburListModel().liburListCustomStore,
                filter: null,
            })
        );
       
        const loadData = async (filter = null) => {
            console.log("liburListStore loadData 1", filter);
            isLoading.value = true;
            try {
                dataSourceLiburList.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourceLiburList.value.load();
                console.log("liburListStore loadData 2", result);
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {        
            try {
                console.log("liburListStore insertData 1", newItem);

                const result = await dataSourceLiburList.value.store().insert(newItem);
                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };

        const updateData = async (updatedRows) => {

            const store = dataSourceLiburList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
          
                // Wait for all update operations to complete
               
                const results = await Promise.all(updatePromises);
          
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceLiburList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourceLiburList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourceLiburList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);